import {IOwayoDataModel} from "../model";
import {MotivDataFromDB} from "../databaseInterfaceClasses";

import {EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";
import globalsObject from "../globalsObject";
import {noop} from "../../global/globalUtils";


export class MotivLoader {
    public static insertMotiv(model: IOwayoDataModel, motivData: MotivDataFromDB) {
        if (model.entwurf.getDesign() !== "Pure") {
            globalsObject.controller.changeDesign("Pure");
        }

        model.entwurf.loadLogoObjects(motivData.logoObjects);
        model.entwurf.loadTextObjects(motivData.textObjects);

        const logoObjects = model.entwurf.getLogoObjects();
        logoObjects.forEach(l=>{
            EventVerteiler.broadcast(SELOBEVENTNAMES.INSERTED, {selOb:l, zIndex:model.entwurf.getZOrderTable().getZIndex(l.id)})
        })
        EventVerteiler.broadcast("logoObjectsLoaded", {logos: logoObjects});
        const textObjects = model.entwurf.getTextObjects();
        textObjects.forEach(l=>{
            EventVerteiler.broadcast(SELOBEVENTNAMES.INSERTED, {selOb:l, zIndex:model.entwurf.getZOrderTable().getZIndex(l.id)})
        })
        EventVerteiler.broadcast("textObjectsLoaded", {texts: textObjects});
    }

    private static loadMotivDataAndWaitForCompletion(url, data): Promise<MotivDataFromDB> {

        globalsObject.resourceManager.registerResource(
            {
                resourceName: "motivResource_" + data.MotivID,
                failHandler: () => MotivLoader.errorHandler("insertMotiv load").invalidAfter("loadMotiv_" + data.MotivID)
            }
        ).load({method: "POST", url, data});

        return new Promise<MotivDataFromDB>((resolve) => {
            globalsObject.resourceManager.createTask("loadMotiv_" + data.MotivID)
                .when("motivResource_" + data.MotivID, "loaded")
                .thenDo((loaded: MotivDataFromDB) => resolve(loaded["motivResource_" + data.MotivID]));
        });
    }

    private static errorHandler = (happenedInThisStep: string) => globalsObject.errorHandler.handleError(
        "ajaxFail",
        happenedInThisStep,
        "could not load motiv, sorry"
    );

    private static changeProductColor(productPaletteColorName: string) {
        EventVerteiler.requestData("getPalettenClusterForColorCode", "BW").then(palettenCluster=>{
            globalsObject.resourceManager.createTask("changeProductColorToColorName")
                .when("palettenCluster_"+palettenCluster, "loaded")
                .thenDo(()=>EventVerteiler.broadcast("changeProductColorToColorName", productPaletteColorName));
        }).catch(noop)

        // EventVerteiler.broadcast("colorChangedEvent", {colorCode: "BW", colorHexValue: colorHexValue, byUser:false})
    }

    public static loadMotiv(model: IOwayoDataModel, motivID, productColor: string | null) {
        globalsObject.resourceManager.executeInvalidation("loadMotiv" + motivID)
        globalsObject.resourceManager.createTask("loadMotiv_" + motivID)
            .when("owayoJSViewerWithSelObs_parts.json_Loaded", "loaded")
            .andWhen("fonts", "loaded")
            // .andWhen("") // die Paletten müssen auch da sein
            .thenDo(() => {
                if (productColor !== null) {
                    MotivLoader.changeProductColor(productColor);
                }


                MotivLoader.loadMotivDataAndWaitForCompletion(
                    "/konfigurator_php/actionmodul/loadMotiv.php",
                    {MotivID: motivID, product:globalsObject.infoFromGetParameters.productInfo.product.webNormalized}
                ).then(data => MotivLoader.insertMotiv(model, data))
            });

    }

}
